  <!-- Footer Start -->
  <footer class="ct-footer footer-dark">
	<!-- Top Footer -->
    <div class="container">
      <div class="footer-top">
        <div class="footer-logo">
          <img src="{{this.logoImage}}" alt="logo">
        </div>
        <div class="footer-buttons">
        </div>
      </div>
    </div>

    <!-- Middle Footer -->
    <div class="footer-middle">
      <div class="container">
        <div class="row">
          <div class="col-xl-9 col-lg-9 col-md-4 col-sm-12 footer-widget">
            <h5 class="widget-title">Information</h5>
            <ul>
              <li> <a routerLink='/'>Home</a> </li>
              <li> <a routerLink='/login' *ngIf="isLogin==='0'">Login </a> </li>
              <li> <a routerLink='/register' *ngIf="isLogin==='0'">Signup </a> </li>
              <li> <a routerLink='/contact'>Contact Us</a> </li>
            </ul>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 footer-widget d-none">
            <h5 class="widget-title">Top Items</h5>
            <ul>
              <li> <a href="">Pepperoni</a> </li>
              <li> <a href="">Swiss Mushroom</a> </li>
              <li> <a href="">Barbeque Chicken</a> </li>
              <li> <a href="">Vegetarian</a> </li>
              <li> <a href="">Ham & Cheese</a> </li>
            </ul>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 footer-widget d-none">
            <h5 class="widget-title">Others</h5>
            <ul>
              <li> <a routerLink='/checkout'>Checkout</a> </li>
              <li> <a routerLink='/cart'>Cart</a> </li>
              <li> <a routerLink='/menu-item-v1'>Product</a> </li>
              <li> <a routerLink='/locations'>Locations</a> </li>
              <li> <a routerLink='/legal'>Legal</a> </li>
            </ul>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 footer-widget">
            <h5 class="widget-title">Social Media</h5>
            <ul class="social-media">
              <li> <a href="" class="facebook"> <i class="fab fa-facebook-f"></i> </a> </li>
              <li> <a href="" class="pinterest"> <i class="fab fa-pinterest-p"></i> </a> </li>
              <li> <a href="" class="google"> <i class="fab fa-google"></i> </a> </li>
              <li> <a href="" class="twitter"> <i class="fab fa-twitter"></i> </a> </li>
            </ul>
            <div class="footer-offer">
              <p>Signup and get exclusive offers and coupon codes</p>
              <a routerLink='/register' class="btn-custom btn-sm shadow-none">Sign Up</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Bottom -->
    <div class="footer-bottom">
      <div class="container">
        <ul>
          <li> <a href="http://cygnuspay.com/privacy" target="_blank">Privacy Policy</a> </li>
          <li> <a href="">Refund Policy</a> </li>
          <li> <a href="">Cookie Policy</a> </li>
          <li> <a href="http://cygnuspay.com/terms" target="_blank">Terms & Conditions</a> </li>
        </ul>
        <div class="footer-copyright">
          <p> Copyright &copy; 2020 <a href="http://cygnuspay.com/">Cygnuspay</a> All Rights Reserved. </p>
          <a href="" class="back-to-top">Back to top <i class="fas fa-chevron-up"></i> </a>
        </div>
      </div>
    </div>

  </footer>
  <!-- Footer End -->
<!-- Customize Modal Start -->
<div class="modal fade" id="customizeModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
       
        <div class="modal-body">

          <div class="customize-meta">
            <div class=" row">
				
				<div class="col-2 col-md-2">
					<img class="orderCartModalSubMenuImage" src="">
				</div>
				<div class="col-7 col-md-7">
					<h4 class="customize-title">
					{{subMeuName}} 
					 </h4>
					<p>{{subMeuDesc}}</p>
			
				</div>
				<div class="col-2 col-md-2">
					<h4 class="customize-title" style="float: right;">
					<span class="custom-primary">$  {{submeuGrandPrice | number : '1.2-2' }}</span> 
					</h4>
			
				</div>
				<div class="col-1 col-md-1">
					<h4 (click) = "closeModalMenu()" class="customize-title" style="float: right;cursor: pointer;">
						<i class="fas fa-times"></i>
					 </h4>
			
				</div>
				
			</div>
			
          </div>

          <div class="customize-variations">

            <div class="customize-size-wrapper">
              <h5 *ngIf="issubmenuSize">Size: </h5>
              
              <div class="customize-size"  *ngFor="let subMeuSize of subMeuSizes ; let indexOfelement=index;" style="width: auto;padding: 10px;">
				<span 
				id="submenusize_{{indexOfelement}}"
				
				(click)="changedtotalPrice(subMeuSize.amount,indexOfelement,subMeuSize.size, subMeuSize.index)"
				[ngClass]="{'selected-size': indexOfelement == 0}">
				
				<span *ngIf="subMeuData.type==='piza'">{{subMeuSize.size_display_name}} </span>
			
				<span *ngIf="subMeuData.type!='piza'">{{subMeuSize.size}}</span>
				 $ ({{subMeuSize.amount | number : '1.2-2'}})</span>
              </div>
            </div>

            <div class="row">

              <!-- Variation Start  -->
			  
			  <div class="col-lg-12 col-12">
				<div  *ngIf="modifersDataSpin" class="category-box-icon d-flex">
					<i class="fas fa-spinner spinner"></i>
				</div>
				
			  </div>
			  
              <div class="col-lg-4 col-12" *ngIf="dealMenuData[0]">
                <div class="customize-variation-wrapper" >
                  <i class="flaticon-bread-roll"></i>
				  <h5>Menus</h5>
					<div class="customize-variation-item"  *ngFor="let dealMenu of dealMenuData">
					  <label class="mb-0 mt-0">{{dealMenu.qty}} {{dealMenu.menu_name}} <span *ngIf="dealMenu.size_display_name!=''">({{dealMenu.size_display_name}})</span></label>
					</div>	
                 
                </div>
              </div>
               <div class="col-lg-4 col-12" *ngFor="let modifer of modifersData;let indexOfelement=index; ">
                <div class="customize-variation-wrapper">
                  <i class="flaticon-bread-roll"></i>
                  <h5>{{modifer.modifier_heading}} 
				  <span *ngIf="modifer.modifier_mandatory ==='1'" style="color:red">(Required)</span></h5>
                  <div >
                  <div class="customize-variation-item" data-price="0.00" 
				  *ngFor="let modifernextdata of modifer.data;let indexOfmodiferdata=index;">
                    
					<div *ngIf="modifer.modifier_type==='1'" class="custom-control custom-radio" style="width: 60%;">
                      
					  <input type="radio" 
					  (change)="onRadioButtonChange($event,modifernextdata,modifer)" 
					  value="{{modifernextdata.amount}}"
					  id="regular_{{modifer.modifier_id}}_{{modifernextdata.index}}" 
					  name="radio_{{indexOfelement}}_{{modifer.modifier_id}}"
					  class="custom-control-input checkboxesmodifers modifier_mandatory_{{modifer.modifier_id}}"
					  *ngIf="modifernextdata.disable==='0'"
					  >
					  
                      <label class="custom-control-label" [ngClass]="{'text-line-through': modifernextdata.disable==='1'}" for="regular_{{modifer.modifier_id}}_{{modifernextdata.index}}">{{modifernextdata.modifier_name}}</label>
					  <br>
					  <span *ngIf="modifernextdata.type==='piza'" class="piza-icons piza-icons-{{modifer.modifier_id}}-{{modifernextdata.index}}">
					   <i class="fas fa-plus fa-qty-modifer" (click)="changeModiferSizesQty(modifernextdata,modifer, 'add', '')"></i>

						<i class="fa fa-adjust fa-3x  fa-circel-icon circel-icon" id="circel-icon-left-{{modifer.modifier_id}}-{{modifernextdata.index}}" (click)="changeModiferSizes(modifernextdata,modifer, 'left', '')">
							
						</i>
						<i class="fa fa-circle fa-3x fa-circel-icon circel-icon" id="circel-icon-full-{{modifer.modifier_id}}-{{modifernextdata.index}}" (click)="changeModiferSizes(modifernextdata,modifer, 'full', '')">
							
						</i>
						<i class="fa fa-adjust fa-3x fa-circel-icon fa-rotate-180 circel-icon"  id="circel-icon-right-{{modifer.modifier_id}}-{{modifernextdata.index}}" (click)="changeModiferSizes(modifernextdata,modifer, 'right', '')">
							
						</i>
						
						<span class="badge badge-light piza-topping-counter piza-top-counter-{{modifer.modifier_id}}-{{modifernextdata.index}}"></span>
						<i class="fas fa-minus  fa-qty-modifer" (click)="changeModiferSizesQty(modifernextdata,modifer, 'minus', '')"></i>

					  </span>
	
					</div>
					<div *ngIf="modifer.modifier_type==='2'" class="custom-control custom-checkbox" style="width: 60%;">
					
						
						<input type="checkbox"  (change)="onCheckboxChange($event,modifernextdata,modifer, '')"  value="{{modifernextdata.amount}}" id="regularDough_{{modifer.modifier_id}}_{{modifernextdata.index}}" name="dough" class="custom-control-input checkboxesmodifers modifier_mandatory_{{modifer.modifier_id}}" *ngIf="modifernextdata.disable==='0'">
						
						
						<label class="custom-control-label" [ngClass]="{'text-line-through': modifernextdata.disable==='1'}" for="regularDough_{{modifer.modifier_id}}_{{modifernextdata.index}}">{{modifernextdata.modifier_name}}</label>
						

						<br>
						<span *ngIf="modifernextdata.type==='piza'" class="piza-icons piza-icons-{{modifer.modifier_id}}-{{modifernextdata.index}}">
						<i class="fas fa-plus fa-qty-modifer" (click)="changeModiferSizesQty(modifernextdata,modifer, 'add', '')"></i>

						<i class="fa fa-adjust fa-3x  fa-circel-icon circel-icon" id="circel-icon-left-{{modifer.modifier_id}}-{{modifernextdata.index}}" (click)="changeModiferSizes(modifernextdata,modifer, 'left', '')"></i>
						<i class="fa fa-circle fa-3x fa-circel-icon circel-icon" id="circel-icon-full-{{modifer.modifier_id}}-{{modifernextdata.index}}" (click)="changeModiferSizes(modifernextdata,modifer, 'full' , '')"></i>
						<i class="fa fa-adjust fa-3x fa-rotate-180 fa-circel-icon circel-icon"  id="circel-icon-right-{{modifer.modifier_id}}-{{modifernextdata.index}}" (click)="changeModiferSizes(modifernextdata,modifer, 'right' , '')"></i>
						
						<span class="badge badge-light piza-topping-counter piza-top-counter-{{modifer.modifier_id}}-{{modifernextdata.index}}"></span>
						
						<i class="fas fa-minus  fa-qty-modifer" (click)="changeModiferSizesQty(modifernextdata,modifer, 'minus', '')"></i>
						
						</span>
					 <!-- <span >{{selectthebyDefaultModifers(modifernextdata,modifer)}}</span> -->
					  
					</div>
                     					  
					<span style="width: 30%;" *ngIf="modifernextdata.type!='piza'">+ $ {{modifernextdata.amount | number : '1.2-2' }} </span>
                  </div>
                  </div>
                 
                 
                </div>
              </div>
              <!-- Variation End -->

              
            </div>
          </div>
			<div class="row mb-2" *ngIf="item_special_instructions_view==='1'">
			<div class="col-12">
				<label>Special Instruction</label>
				<textarea class="form-control" id="special_instruction" rows="5"></textarea>
            </div>
            </div>
          <div class="customize-controls">
            <div class="qty">
			  
              <span class="qty-subtract" (click)="updateQuatity('minus')"><i class="fas fa-minus"></i></span>
              <input type="number"  value="1" class="qtyvalue" (change)="changeQuatity()">
              <span class="qty-add" (click)="updateQuatity('add')"><i class="fas fa-plus"></i></span>
            </div>
			
			
            
			
			<div class="customize-total" data-price="13.99" style="display:none">
              <h5>Total Price: <span class="final-price custom-primary">$ {{submeuGrandPrice | number : '1.2-2' }} <span></span> </span> </h5>
            </div>
          </div>
		  <div *ngIf="bookOrderValidationMessage!=''"class="alert alert-danger" role="alert">
			  <strong>Missing Modifiers..!!</strong> Please make a choice for {{bookOrderValidationMessage}}
			</div>	
          <button type="button" class="btn-custom btn-block" id="orderNow"  (click)="subMenuOrderSave()">Order Now</button>

        </div>
      </div>
    </div>
  </div>
  <!-- Customize Modal End -->
	
  <!-- Cart Sidebar Start -->
   <div class="cart-sidebar-wrapper">
    <aside class="cart-sidebar">
      <div class="cart-sidebar-header">
        <h3>Your Cart 
		<span style="font-size: 19px;">{{myCartDateTime}} 
			<span class="time-picker-color " (click)="openTimePickerModel()"> (Change)</span>
		</span>
		<!-- <timepicker [(ngModel)]="mytime" (ngModelChange)="changed()" ></timepicker> -->
		</h3>
        <div class="close-btn cart-trigger close-dark">
          <span></span>
          <span></span>
        </div>
      </div>
	  <div>

      <div class="cart-sidebar-body">
        <!-- <div class="scroll-window" slimScroll [options]="opts" 
		[scrollEvents]="scrollEvents" slimScroll [options]="opts"
		[scrollEvents]="scrollEvents"> -->
		<div class="scroll-window" style="overflow:auto">
          <div class="cart-sidebar-item pb-2 pt-2 pr-2" *ngFor="let cartdata of cartModelData;let indexOfelement=index;">
            <div class="media media-sidebar mb-0
			">
              <a  class="cartMenuImages">
				<img *ngIf="cartdata.ItemType==='M'" [src]="BASEURL_SUBMENU_IMGS+cartdata.submenuImage" 
					(error)="cartErrorUpdateUrl(indexOfelement)"
					id="cart_image_{{indexOfelement}}" style="width:100px" class="pr-2"> 
				
				<img *ngIf="cartdata.ItemType==='D'" [src]="BASEURL_DEAL_IMGS+cartdata.submenuImage" 
					(error)="cartErrorUpdateUrl(indexOfelement)"
					id="cart_image_{{indexOfelement}}" style="width:100px" class="pr-2"> 
			  </a>
              <div class="media-body">
				<div class="row">
				<div class="col-md-7 col-7">
					 <h5 style="white-space: pre-line;"> <a  title="Pepperoni">{{cartdata.ItemQty}} - {{cartdata.subMeuName}}</a>
						<b *ngIf="cartdata.ItemSizeDisplayName!=''; else elseBlock"  > - {{cartdata.ItemSizeDisplayName}}  <br></b>
						<ng-template #elseBlock>  
							<b></b>
						</ng-template> 
					</h5>
					
				</div>
				<div class="col-md-3 col-3">
					<b class="pull-right submenuamount" style="float: right;">$ {{cartdata.ItemBasePrice*cartdata.ItemQty | number : '1.2-2' }} </b>
				</div>
				<div class="col-md-2 col-2">
					<div style="float: right;" class="close-btn"
					(click)="deleteItemFromCart(indexOfelement)">
					  <span></span>
					  <span></span>
					</div>
				</div>
				</div>
                
				<div class="row" *ngFor="let addOn of cartdata.addOns">
				<div class="col-md-6 col-6">
					<p class="pl-3">
					
					<i class="fa fa-adjust fa-3x fa-circel-icon" *ngIf="addOn.pizaextra_name==='left'"></i>
					<i class="fa fa-circle fa-3x fa-circel-icon" *ngIf="addOn.pizaextra_name==='full'"></i>
					<i class="fa fa-adjust fa-3x fa-rotate-180 fa-circel-icon" *ngIf="addOn.pizaextra_name==='right'"></i>
					{{addOn.name}}
					<span *ngIf="addOn.pizaextra_price_qty>1"> X {{addOn.pizaextra_price_qty}}</span>
					</p>
				</div>
				<div class="col-md-4 col-6">
					<span class="pull-right" style="float: right;" *ngIf="addOn.pizaextra_name===''">{{addOn.amount*cartdata.ItemQty | number : '1.2-2'  }} </span>
					<span class="pull-right" style="float: right;" *ngIf="addOn.pizaextra_name!=''">{{pizaToppingPriceCart(cartdata,addOn ) }} </span>
				</div>
				</div>
				
				<div class="row" *ngIf = "cartdata.ItemInstructions!='' && item_special_instructions_view==='1'">
				<div class="col-md-12 col-12">
					<i class="fas fa-edit" aria-hidden="true" (click)="openUpdateCartInstructionModal(cartdata, indexOfelement)" style="cursor: pointer;font-size:14px"></i>
					<i  style="font-style: italic;font-size:14px;word-break: break-all;">{{cartdata.ItemInstructions}}</i>
				</div>
				</div>
				
			  </div>
            </div>
          </div>
        
		</div>
      </div>
      </div>
      <div class="cart-sidebar-footer pt-3 pb-3" style="display:block">
		<div class="row">
		
		<div class="col-md-6 col-6">
			<b>Sub Total</b>
		</div>
		<div class="col-md-6 col-6">
			<b style="float:right">$ {{cartTotalBalance | number : '1.2-2' }}</b>
		</div>
		<div class="col-md-6 col-6">
			<b>Discount</b>
		</div>
		<div class="col-md-6 col-6">
			<b style="float:right">0.00</b>
		</div>
		<div class="col-md-12">
				<p class="m-0 p-0">The TAX will be calculated after choosing a store</p>
		</div>
		
		<div class="col-md-6 col-6">
			<h4>Total</h4>
		</div>
		<div class="col-md-6 col-6">
			<h4 style="float:right">$ {{cartTotalBalance | number : '1.2-2' }} </h4>
		</div>
		<div class="col-md-10 mt-2">
			<button class="btn btn-outline-danger p-1 m-1"
			*ngFor="let serviceType of cartModelService" 
			[ngClass]="{'btn-outline-danger': serviceType != selectedOrderServiceType, 'btn-danger':serviceType === selectedOrderServiceType }"
			>
				<span (click)="selectedOrderService(serviceType)">{{serviceType}}</span>
			</button>
		</div>
		<div class="col-md-2 mt-2" >
			<a  [ngClass]="{'disable-button' : is_d_error==='0'}" *ngIf="isLogin==='0' && isCartData==='1'; else elseBlock"  
			(click)="loginModal()" class="btn-custom cart-trigger" style="color:white;float: right;">Continue to select location</a>
			<ng-template #elseBlock>  
					<a  [ngClass]="{'disable-button' : is_d_error==='0'}" *ngIf="isLogin==='1' && isCartData==='1'" 
					(click)="pageRedirect('/locations')" class="btn-custom cart-trigger" style="color:white;float: right;">Continue to select location</a>
			</ng-template>
		</div>
		</div>
        
      </div>
    </aside>
    <div class="cart-sidebar-overlay cart-trigger">
    </div>
  </div>
 
  
  
  <!-- Cart Sidebar End -->
	<div class="modal fade" id="updateItemInstruction" 
	tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
        <label class="p-2 m-2"><b>Update Instructions ({{editCartObject.subMeuName}})</b></label>
		<hr>
		<div class="container">
        <div class="col-md-12">
			<textarea class="form-control update-instruction" rows="5" cols="10"></textarea>
		</div>
		</div>
        <div class="modal-body">
          <button type="button" class="btn-custom btn-block" data-dismiss="modal" (click)="updateInst()" >Update</button>
        </div>
      </div>
    </div>
    </div> 
	
	<!-- Cart Sidebar End -->
	<div class="modal fade" id="serviceTypeDelivery" 
	tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
	    <label class="p-2 m-2"><b>Delivery Address</b></label>
		<hr>
		
		<div class="row pl-4 pr-4">
			<div class="col-xl-12">
				<div *ngIf="cartModelServiceErrorMessage!=''" class="alert alert-danger" role="alert">
				  <strong>Error..!!</strong> {{cartModelServiceErrorMessage}}
				</div>
			</div>
			
			<div class="col-xl-12 form-group">
			  <label>Location <span class="text-danger">*</span></label>
			  <input type="text" 
				class="serviceTypeDeliveryinput form-control addressgoogleauto" 
					placeholder="" value=""  autocomplete="off" 
				(onAddressChange)="handleAddressChange($event)">
			</div>
			<div class="col-xl-6 ">
			  <label>Apartment#</label>
			  <input type="text" class="serviceTypeDeliveryinput form-control"  name="" id="apartment" value="">
			</div>
			<div class="col-xl-6 ">
			  <label>Zip Code <span class="text-danger">*</span></label>
			  <input type="text" class="serviceTypeDeliveryinput form-control"  id="zipcode" name=""  value="">
			</div>
		</div>
		
        <div class="modal-body">
			<button type="button" style="width:50%;margin-top:0px" class="btn-custom btn-block" data-dismiss="modal"  >Cancel</button>
       
		  <button type="button" style="width:50%;margin-top:0px;font-weight: 600;
			padding: 12px 30px; border-radius:25px"
		  class="btn btn-success"  (click)="serviceTypeDeliveryProcessed()" >PROCEED</button>
         </div>
      </div>
    </div>
    </div> 
	
	<!-- Cart Sidebar End -->
	<div class="modal fade" id="openTimePickerModel" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content">
        <label class="p-2 m-2"><b>Select date and time</b></label>
		<hr>
		<div class="container">
        <div class="col-md-12" *ngIf="is_future_enable==='1'">
			<label>Select Date</label>
			 <input type="text"
			 placeholder="Datepicker"
			 class="form-control"
			 bsDatepicker
			 [bsValue]="bsValue"
			 [minDate]="minDate"
			 [maxDate]="maxDate"
			 [(ngModel)]="orderDateSelected"
			 [bsConfig]="{ isAnimated: true, dateInputFormat: 'YYYY-MM-DD' }"
			 readonly
			 (bsValueChange)="datepickerChange($event)"
			 >
			
		</div>
		<div class="col-md-12">
			<label>Select Time</label>
			
			<timepicker [(ngModel)]="mytime" (ngModelChange)="changed()" [min]="minTime" [max]="maxTime" ></timepicker>
		</div>
		</div>
        <div class="modal-body">
          <button type="button" class="btn-custom btn-block" data-dismiss="modal" (click)="updateDateTime()">Ok</button>
        </div>
      </div>
    </div>
    </div>

<div class="modal fade" id="login-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Login</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
	 
	  <div class="modal-body">
			<p class="alert alert-danger" *ngIf="loginErrorMessage!=''">{{loginErrorMessage}}</p>
		    <div class="form-group">
			<label for="exampleInputEmail1">Email address</label>
			<p>
				<input type="email" class="form-control form-control-light" placeholder="Email" name="login-md-email" value="" id="login-md-email">
			</p>
		    </div>
		    
			<div class="form-group">
				<p >
				<input type="password" formControlName="password" 
				class="form-control form-control-light"
				placeholder="Password" name="password" id="login-md-password" autocomplete="new-password">
				</p>
			</div>
			<div   class="category-box-icon d-flex" *ngIf="loginSpin">
				<i class="fas fa-spinner spinner"></i>
			</div>
			<button type="submit" class="btn btn-primary btn-block" (click)="loginProccess()"  *ngIf="!loginSpin" style="background: #ED4E53;border: unset;">Login</button>
			<div class="auth-seperator m-0">
              <span>OR</span>
            </div>
			<button type="submit" class="btn btn-success btn-block"  (click)="loginGuestProccess()"  *ngIf="!loginSpin">Login As Guest</button>
		    <p  style="cursor: pointer;text-align:center;margin-bottom: 0px;margin-top: 10px;" (click)="forGotPassword()">Forgot Password?</p>
			<p style="cursor: pointer;text-align:center;margin-bottom: 0px;">Don't have an account? <a (click)="pageRedirect('register')" style="color:blue;text-decoration:underline">Create One</a> </p>

	  </div>
      

    </div>
  </div>
</div>

<div class="modal fade" id="forgotPassword-footer" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Forgot Password</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
	  <form [formGroup]="forgotForm"  (ngSubmit)="forGot()" autocomplete="off">
	  <div class="modal-body">
	 	 <div *ngIf="forGotPasswordMessageApi!=''" class="alert alert-primary">
				  <strong> {{forGotPasswordMessageApi}} </strong>
		  </div>
		  <div class="form-group">
			<label for="exampleInputEmail1">Email address</label>
			<p [ngClass]="{ 'has-error': isSubmittedForgot && formControlsforgot.forgotemail.errors }">
				<input type="email" formControlName="forgotemail" 
				class="form-control form-control-light"
				placeholder="Email" name="forgotemail" value="">
			</p>
			
			<div  *ngIf="formControlsforgot.forgotemail.errors"
			  style="text-align: left;color: red;">
				<span *ngIf="formControlsforgot.forgotemail.errors.email">Email must be a valid email address</span>
		    </div>
			
		  </div>
	  </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
		<div  *ngIf="forGotPasswordSpin" class="category-box-icon d-flex">
			<i class="fas fa-spinner spinner"></i>
		</div>
		<button type="submit" class="btn btn-primary"  *ngIf="!forGotPasswordSpin">Submit</button>
      </div>
	  </form>

    </div>
  </div>
</div>

  <!-- Search Form Start-->
  <div class="search-form-wrapper">
    <div class="search-trigger close-btn">
      <span></span>
      <span></span>
    </div>
    <form class="search-form" method="post">
      <input type="text" placeholder="Search..." value="">
      <button type="submit" class="search-btn">
        <i class="flaticon-magnifying-glass"></i>
      </button>
    </form>
  </div>
  <!-- Search Form End-->